import React, { useEffect, useState } from "react";
import PageLayout from "../../components/PageLayout";
import WishSimpleCard from "../../components/WishSimpleCard";
import data from "../../data/Data.json";
import Pagination from "../../components/Pagination";
import useReport from "../../services/useReport";
import SkeletonLoader from "../../components/SkeletonLoader";
import { AppUtils } from "../../services/AppUtils";

export default function CustomerLeadReport({ isWebview = false }) {
  const breadcrumbs = [];
  breadcrumbs.push({ title: "Home", linkTo: "/" });
  breadcrumbs.push({ title: "Reports & Trends", linkTo: "/reportsandtrends" });
  breadcrumbs.push({ title: "Customer Re-order leads", linkTo: "/customerreorderleads" });

  const { getCustomerLeads } = useReport(JSON.parse(localStorage.getItem("distributor")).distributor_id);
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [payload, setPayload] = useState({
    distributor_id: JSON.parse(localStorage.getItem("distributor")).distributor_id,
    page_no: 1,
    total_no_of_pages: 0,
  });

  useEffect(() => {
    getLists();
  }, []);

  const getLists = () => {
    setLoading(true);
    getCustomerLeads(
      payload,
      (data) => {
        setLoading(false);
        setReport(data);
      },
      (error) => {
        setLoading(true);
      }
    );
  };

  const renderData = function () {
    return (
      <WishSimpleCard>
        {loading ? (
          <>
            <SkeletonLoader rows={12} />
          </>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Distributor ID</th>
                  <th scope="col">Customer</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Last ordered on</th>
                  <th scope="col">Product</th>
                  <th scope="col">Storelink</th>
                </tr>
              </thead>
              <tbody>
                {report?.report?.length > 0 ? (
                  report?.report?.map((item) => (
                    <tr>
                      <td>{item.distributor_id}</td>
                      <td>{item.customer_fullname}</td>
                      <td>{item.customer_phone}</td>
                      <td>{AppUtils.formatDate(item.create_time)}</td>
                      <td>{item.product_name}</td>
                      <td>{item.link}</td>
                    </tr>
                  ))
                ) : (
                  <tr className="text-center mt-2">
                    <td colspan="5">No items</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
        {/* <div className="d-flex justify-content-between align-items-center card-footer border-top-lighten-5 align-items-baseline">
          <Pagination
            pageno={report?.page_no}
            onPageChange={(page) => {
              payload.page_no = page;
              getLists();
            }}
            totalPages={report?.total_no_of_pages}
          />
        </div> */}
      </WishSimpleCard>
    );
  };

  return (
    <PageLayout activeSideMenu="9" pageTitle="Reports" header={`Customer Re-order leads`} breadcrumbs={breadcrumbs}>
      <h6>You can view the list of customers whose products will have finished within the coming 4 days here.</h6>
      {renderData()}
    </PageLayout>
  );
}
